<template>
  <div>
    <section class="section section-lg bg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <figure class="walden">
              <router-link to="/contact">
                <img class="cropped" src="img/stock/john-mark-smith-397655-unsplash.jpg">
              </router-link>
            </figure>
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5 copy">
              <h1 class="display-1 text-primary">Insurance</h1>
              <p>Your peace of mind is priceless. Knowing that you are covered in any event, planned or not, is true peace of mind.</p>
              <p>Forward Financial provides our clients with holistic insurance solutions to cover every aspect of their personal and professional lives.</p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-stethoscope"></badge>
                    <h6 class="mb-0">Health Insurance</h6>
                  </div>
                </li>
				<li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-user-md"></badge>
                    <h6 class="mb-0">Medicare Insurance</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-heartbeat"></badge>
                    <h6 class="mb-0">Life Insurance</h6>
                  </div>
				  <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-car"></badge>
                    <h6 class="mb-0">Auto Insurance</h6>
                  </div>
				  <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-home"></badge>
                    <h6 class="mb-0">Homeowners Insurance</h6>
                  </div>
                </li>
				<li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-briefcase"></badge>
                    <h6 class="mb-0">Business/Commercial Insurance</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <free-consultation/>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton";
import FreeConsultation from "./FreeConsultation.vue";
export default {
  name: "Services",
  components: {
    BaseButton,
    FreeConsultation
  }
};
</script>